//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { TermType } from './TermType';
  
  export class TermModel extends ModelBase {
      static readonly $typeName = 'TermModel';
      public isPreferred: boolean;
      public languageCode: string;
      public name: string;
      public termType: TermType;
      public termKey: string;
      public key: string;
      public cannotEdit: boolean;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/TermModel.ts